import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdjustIcon(props: IconProps) {
    return <Icon {...props} iconKey={"adjust"}/>
}
